module.exports = __webpack_public_path__ + "download-icon@2x.png?f6dc59f202d4ed3a4668a0e8bc04b915";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download-icon@2x.png
// module id = 28
// module chunks = 0